import { render, staticRenderFns } from "./ButtonOpenDialog.vue?vue&type=template&id=825a07ae"
import script from "./ButtonOpenDialog.vue?vue&type=script&lang=js"
export * from "./ButtonOpenDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports